import './App.css';
import Home from './components/Home';
import About1 from './components/About1';
import Producta from './components/Producta';
import Productb from './components/Productb';
import Productc from './components/Productc';
import Productd from './components/Productd';
import Producte from './components/Producte';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';
import Footer from './components/Footer';


function App() {
  return (
    <div className="App">
      <Home/>
      <About1/>
      <Producta/>
      <Productb/>
      <Productc/>
      <Productd/>
      <Producte/>
      <Testimonial/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
